import {IMacronutrientDistributionValues} from './interfaces/macronutrient-distribution-values.interface';
import {IDistributionProperty} from './interfaces/distribution-property.interface';
import {MacronutrientDistributionNamespace} from '../../models/meal-plan-builder';

export interface IMacroDistributionResponse {
  isHigher?: boolean;
  isLower?: boolean;
  messageReferenceValue?: string;
  messageChoiceValue?: string;
}

export interface IMacroDistributionMetadata {
  block: boolean;
  value: number;
  defaultValue: number;
}

export abstract class MacronutrientDistribution {
  carbohydrates: IDistributionProperty;
  lipids: IDistributionProperty;
  protein: IDistributionProperty;
  fiber: IDistributionProperty;

  verify(values: IMacronutrientDistributionValues): void {
    const total = values.carbohydrate_g + values.dietaryFiber_g + values.totalFat_g + values.protein_g;
    // lanzará el método verify de cada propiedad
    this.carbohydrates.verify(values.carbohydrate_g, total);
    this.lipids.verify(values.totalFat_g, total);
    this.protein.verify(values.protein_g, total);
    this.fiber.verify(values.dietaryFiber_g, total);
  }




  getAlertMessages(): string[] {
    return [
      this.carbohydrates.response?.messageReferenceValue || '',
      this.lipids.response?.messageReferenceValue || '',
      this.protein.response?.messageReferenceValue || '',
      this.fiber.response?.messageReferenceValue || '',
      this.carbohydrates.response?.messageChoiceValue || '',
      this.lipids.response?.messageChoiceValue || '',
      this.protein.response?.messageChoiceValue || '',
      this.fiber.response?.messageChoiceValue || ''
    ];
  }
  init(value: IMacronutrientDistributionValues): void {
    // suma de gramos
    const total = value.carbohydrate_g + value.dietaryFiber_g + value.totalFat_g + value.protein_g;

    this.carbohydrates.setValue(
      value.carbohydrate_g > 0 ?
        Math.round(((value.carbohydrate_g * 100) / total)) :
        55
    );
    this.lipids.setValue(
      value.totalFat_g > 0 ?
        Math.round(((value.totalFat_g * 100) / total)) :
        30
    );
    this.protein.setValue(
      value.protein_g > 0 ?
        Math.round(((value.protein_g * 100) / total)) :
        15
    );
    this.fiber.setValue(
      value.dietaryFiber_g > 0 ?
        Math.round(((value.dietaryFiber_g * 100) / total)) :
        0
    );
  }

  setValues(values: MacronutrientDistributionNamespace.IMacronutrient): void {
    const macros = Object.keys(values);
    macros.forEach(macro => {
      this[macro].setDefaultValue(values[macro].defaultValue);
      this[macro].setValue(values[macro].value);
      this[macro].setBlock(values[macro].block);
    });
  }
}
